(function () {
  function setHidden(el, hide) {
    if (!el) return;
    el.hidden = hide;
    el.classList.toggle('hidden', hide);
  }

  function setDisabled(el, disabled) {
    if (!el) return;
    el.disabled = disabled;
  }

  function setRequired(el, required) {
    if (!el) return;
    if (required) {
      el.setAttribute('required', 'required');
      el.setAttribute('aria-required', 'true');
    } else {
      el.removeAttribute('required');
      el.removeAttribute('aria-required');
    }
  }

  function toggleExtraField(wrapper, input, visible) {
    setHidden(wrapper, !visible);
    setDisabled(input, !visible);
    setRequired(input, visible && input && input.hasAttribute('data-enquiry-required-when-visible'));
    if (!visible && input) {
      input.value = '';
    }
  }

  function selectedOption(select) {
    return select.options[select.selectedIndex] || null;
  }

  function populateReasonSelect(reasonSelect, rawOptions) {
    if (!reasonSelect) return;

    const placeholder = reasonSelect.querySelector('option[value=""]');
    const placeholderText = placeholder ? placeholder.textContent : 'Select a reason';
    reasonSelect.innerHTML = '';

    const placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.disabled = true;
    placeholderOption.selected = true;
    placeholderOption.textContent = placeholderText;
    reasonSelect.appendChild(placeholderOption);

    String(rawOptions || '')
      .split('|')
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean)
      .forEach(function (label) {
        const option = document.createElement('option');
        option.value = label;
        option.textContent = label;
        reasonSelect.appendChild(option);
      });
  }

  function init(root) {
    const form = root.closest('form') || root.querySelector('form');
    const select = root.querySelector('[data-enquiry-select]');
    const submitFields = root.querySelector('[data-enquiry-submit-fields]');
    const submitButton = root.querySelector('[data-enquiry-submit]');
    const gates = root.querySelectorAll('[data-enquiry-gate]');
    const orderWrap = root.querySelector('[data-enquiry-order]');
    const reasonWrap = root.querySelector('[data-enquiry-reason]');
    const orderInput = orderWrap ? orderWrap.querySelector('input') : null;
    const reasonInput = reasonWrap ? reasonWrap.querySelector('select, input') : null;
    const requiredInputs = root.querySelectorAll('[data-enquiry-required]');

    if (!form || !select) return;

    function apply() {
      const option = selectedOption(select);
      const mode = option && option.value ? option.getAttribute('data-mode') : '';
      const label = option ? option.value : '';

      gates.forEach(function (gate) {
        const match = gate.getAttribute('data-enquiry-label') === label;
        setHidden(gate, !(mode && mode !== 'submit' && match));
      });

      const canSubmit = mode === 'submit';
      setHidden(submitFields, !canSubmit);
      setDisabled(submitButton, !canSubmit);

      requiredInputs.forEach(function (input) {
        setRequired(input, canSubmit);
        setDisabled(input, !canSubmit);
      });

      const showOrder = canSubmit && option && option.getAttribute('data-show-order') === 'true';
      const showReason = canSubmit && option && option.getAttribute('data-show-reason') === 'true';

      toggleExtraField(orderWrap, orderInput, showOrder);

      if (showReason) {
        populateReasonSelect(reasonInput, option.getAttribute('data-reason-options'));
      }
      toggleExtraField(reasonWrap, reasonInput, showReason);
    }

    select.addEventListener('change', apply);

    form.addEventListener('submit', function (event) {
      const option = selectedOption(select);
      const mode = option ? option.getAttribute('data-mode') : '';
      if (mode !== 'submit') {
        event.preventDefault();
        return;
      }

      [orderInput, reasonInput].forEach(function (input) {
        if (!input || input.disabled) return;
        if (!String(input.value || '').trim()) {
          input.value = '';
          input.disabled = true;
        }
      });
    });

    root.querySelectorAll('[data-faq-scroll]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        const anchor = link.getAttribute('data-faq-scroll');
        const target = document.getElementById(anchor);
        if (!target) return;
        event.preventDefault();

        const headerHeight = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--header-height')
        );
        const offset = (Number.isFinite(headerHeight) ? headerHeight : 80) + 72;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    });

    apply();
  }

  function urlWantsContactSuccess() {
    var params = new URLSearchParams(window.location.search);
    var preview = params.get('contact_success');
    var posted = params.get('contact_posted');
    return preview === '1' || preview === 'true' || posted === 'true';
  }

  function persistContactSuccessQuery() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('contact_success') === '1') return;
    params.set('contact_success', '1');
    params.delete('contact_posted');
    var next = window.location.pathname + '?' + params.toString() + window.location.hash;
    window.history.replaceState({}, '', next);
  }

  function renderContactSuccess(form) {
    var copy = { heading: 'Message sent', body: '' };
    var copyEl = document.getElementById('ContactFormSuccessCopy');
    try {
      if (copyEl && copyEl.textContent) copy = JSON.parse(copyEl.textContent);
    } catch (err) {}
    form.innerHTML =
      '<div class="contact-complete" role="status" tabindex="-1">' +
      '<div class="heading-border-section contact__heading"><h2>' +
      String(copy.heading || '') +
      '</h2></div>' +
      '<div class="contact-complete__body" style="color:#2e2e2f !important; font-family:Montserrat, sans-serif; font-size:16px; font-weight:500; line-height:1.45; margin:22px 0 0;">' +
      String(copy.body || '') +
      '</div></div>';
  }

  document.querySelectorAll('form.contact__form').forEach(function (form) {
    if (form.querySelector('.contact-complete')) return;
    if (!urlWantsContactSuccess()) return;
    persistContactSuccessQuery();
    renderContactSuccess(form);
  });

  document.querySelectorAll('[data-contact-enquiry]').forEach(init);
})();
